export default "__VITE_ASSET__PMk4BmOt__"